import { basicValidation } from "../modules/fieldValidation/basicValidation";

export const stringUtil = {
    parseIntegerOrDefault,
    zeroPad,
    capTextLength,
    generateNextSequenceName,
    uniqueStrings
}


function parseIntegerOrDefault(str: string, defaultValue: number): number {
    if (basicValidation.validateIntegerString(str))
        return parseInt(str);

    return defaultValue;
}

function zeroPad(val:number, digitCount:number)
{
    let str = val.toString();
    while(str.length < digitCount)
        str = '0' + str;

    return str;
}

function capTextLength(val:string, maxLength:number)
{
    if(val.length <= maxLength)
        return val;

    return val.substring(0, maxLength-3) + '...';
}

function generateNextSequenceName(nameBase:string, namesInUse:string[])
{
    if(namesInUse.every(n => !n.match(new RegExp(`${nameBase}( \\d+)?`)))){
        return nameBase;
    }

    const usedNs: number[] = [];
    for(const n of namesInUse){
        const match = n.match(new RegExp(`${nameBase} (\\d+)`));
        if(match){
            usedNs.push(parseInt(match[1]));
        }
    }

    if(usedNs.length === 0)
        return nameBase + " 1";

    return nameBase + " " + (Math.max(...usedNs) + 1);
}

function uniqueStrings(values:string[])
{
    const uniqueValues = new Set<string>();
    for(const v of values)
        uniqueValues.add(v);

    return Array.from(uniqueValues);
}

export function forgiveWhitespaceAndCase(str:string)
{
    return str.replace(/\s+/g, '').toLocaleLowerCase();
}